
import Button from '../../../components/base/Button';

export default function FeaturedPropertiesSection() {
  const properties = [
    {
      id: 1,
      title: '新築分譲マンション',
      location: '渋谷区恵比寿',
      price: '8,980万円',
      type: 'マンション',
      rooms: '3LDK',
      area: '78.5㎡',
      age: '新築',
      station: 'JR山手線「恵比寿」駅',
      walkTime: '徒歩5分',
      image: 'https://public.readdy.ai/ai/img_res/310f7768bc580199381a6c537058d40d.jpg.%20The%20building%20should%20appear%20prestigious%20and%20newly%20constructed%2C%20representing%20high-end%20urban%20living.%20Professional%20architectural%20photography%20with%20clean%20lines%2C%20modern%20materials%2C%20and%20attractive%20lighting%20during%20golden%20hour.&width=400&height=300&seq=property-mansion-1&orientation=landscape',
      features: ['南向きバルコニー', 'システムキッチン', 'オートロック', '宅配ボックス'],
      isNew: true
    },
    {
      id: 2,
      title: '角地一戸建て',
      location: '世田谷区成城',
      price: '1億2,800万円',
      type: '一戸建て',
      rooms: '4LDK',
      area: '125.8㎡',
      age: '築3年',
      station: '小田急線「成城学園前」駅',
      walkTime: '徒歩8分',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20corner-lot%20single-family%20house%20with%20modern%20Japanese%20architecture%2C%20featuring%20a%20well-maintained%20garden%2C%20elegant%20exterior%20design%2C%20and%20premium%20residential%20neighborhood%20setting.%20The%20house%20should%20appear%20spacious%20and%20family-friendly%20with%20contemporary%20styling%20and%20professional%20landscaping.%20Natural%20lighting%20and%20welcoming%20atmosphere.&width=400&height=300&seq=property-house-1&orientation=landscape',
      features: ['角地', '駐車場2台', '庭付き', '床暖房'],
      isNew: false
    },
    {
      id: 3,
      title: 'タワーマンション',
      location: '港区六本木',
      price: '1億5,500万円',
      type: 'マンション',
      rooms: '2LDK',
      area: '85.2㎡',
      age: '築5年',
      station: '東京メトロ日比谷線「六本木」駅',
      walkTime: '徒歩3分',
      image: 'https://readdy.ai/api/search-image?query=Impressive%20modern%20tower%20condominium%20building%20rising%20against%20the%20Tokyo%20skyline%2C%20featuring%20sleek%20glass%20and%20steel%20construction%20with%20luxurious%20amenities.%20The%20building%20should%20convey%20prestige%20and%20urban%20sophistication%20with%20modern%20architectural%20elements%20and%20professional%20photography.%20Evening%20lighting%20showcasing%20the%20building%20prominence%20in%20the%20cityscape.&width=400&height=300&seq=property-tower-1&orientation=landscape',
      features: ['高層階', 'コンシェルジュ', 'ジム・プール', '都心一望'],
      isNew: false
    },
    {
      id: 4,
      title: 'デザイナーズマンション',
      location: '目黒区中目黒',
      price: '6,800万円',
      type: 'マンション',
      rooms: '2LDK',
      area: '68.5㎡',
      age: '築2年',
      station: 'JR山手線「中目黒」駅',
      walkTime: '徒歩4分',
      image: 'https://readdy.ai/api/search-image?query=Stylish%20designer%20condominium%20with%20unique%20architectural%20features%2C%20contemporary%20facade%20design%2C%20and%20artistic%20elements.%20The%20building%20should%20showcase%20modern%20design%20aesthetics%20with%20creative%20architectural%20details%2C%20premium%20materials%2C%20and%20sophisticated%20urban%20living%20concept.%20Professional%20photography%20highlighting%20the%20distinctive%20design%20elements.&width=400&height=300&seq=property-designer-1&orientation=landscape',
      features: ['デザイナーズ', '天井高3m', 'カウンターキッチン', 'ルーフバルコニー'],
      isNew: true
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            新着・おすすめ物件
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            厳選した優良物件をピックアップしてご紹介
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {properties.map((property) => (
            <div key={property.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <div className="relative">
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-48 object-cover object-top"
                />
                {property.isNew && (
                  <div className="absolute top-3 left-3 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-semibold">
                    NEW
                  </div>
                )}
                <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
                  {property.type}
                </div>
              </div>
              
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-900 mb-2 line-clamp-1">
                  {property.title}
                </h3>
                
                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <i className="ri-map-pin-line mr-1"></i>
                  {property.location}
                </div>
                
                <div className="text-2xl font-bold text-blue-600 mb-3">
                  {property.price}
                </div>
                
                <div className="space-y-1 text-sm text-gray-600 mb-4">
                  <div className="flex justify-between">
                    <span>間取り:</span>
                    <span className="font-semibold">{property.rooms}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>面積:</span>
                    <span className="font-semibold">{property.area}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>築年数:</span>
                    <span className="font-semibold">{property.age}</span>
                  </div>
                </div>
                
                <div className="text-sm text-gray-600 mb-4">
                  <div className="flex items-center">
                    <i className="ri-train-line mr-1"></i>
                    <span>{property.station}</span>
                  </div>
                  <div className="text-right text-blue-600 font-semibold">
                    {property.walkTime}
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-1 mb-4">
                  {property.features.slice(0, 2).map((feature, index) => (
                    <span key={index} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                      {feature}
                    </span>
                  ))}
                  {property.features.length > 2 && (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                      +{property.features.length - 2}
                    </span>
                  )}
                </div>
                
                <Button variant="outline" className="w-full text-sm">
                  詳細を見る
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <Button size="lg" className="px-8">
            すべての物件を見る
          </Button>
        </div>
      </div>
    </section>
  );
}
